import axios from "axios";
import { getOrRefreshFirebaseToken } from "../../config/getFirebaseToken";

export default async function removeEquipmentFromCarnet(carnetId, equipmentId, prefix) {
  const token = await getOrRefreshFirebaseToken();

  const res = await axios.delete(
    `${prefix}carnets/${carnetId}/equipments/${equipmentId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return res.data;
}
